import { quickOrderPageContainerStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderPageContainer";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { borderBottomTitlesStyles } from "@store/theme/common/mixins";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(quickOrderPageContainerStyles, {
    container: {
        gap: 0,
    },
    firstGridItem: {
        width: 12,
        css: css`
            ${borderBottomTitlesStyles()}

            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [
                        {
                            values: ["20px !important", null, "40px !important", null, null],
                            properties: ["margin-bottom"],
                        },
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    innerContainer: {
        gap: 0,
    },
});
